import { Button, message } from "antd";
import { FC, ReactNode, useState } from "react";
import { backStep, circle3StepButton } from "../../../../assets/SVGs/SVGs";
import { Steps as AntSteps } from "antd";
import DocumentsStep from "./steps/DocumentsStep";
import PaymentGateway from "./steps/PaymentGateway";
import SubmittedDetails from "./steps/SubmittedDetails";
import { useIntl } from "react-intl";
import { useMutation } from "@tanstack/react-query";
import { uploadLocationDocuments } from "../../../../network/onlineBooking";
import { useSelector } from "react-redux";
import queryClient from "../../../../services/react-query/queryClient";
interface OverViewModalWrapperProps {}
const customDotRender = (dot: any, { status }: any) => {
  let dotContent = null;

  switch (status) {
    case "process":
      dotContent = (
        <div
          className={`custom-dot custom-dot-${status} flex items-center -mt-[9px] -mr-3`}
          style={{
            padding: "8px",
            borderRadius: "50%",
            border: "6px solid #EEF0FF",
            backgroundColor: "#00086D",
          }}
        />
      );
      break;
    case "finish":
      dotContent = (
        <div
          className={`custom-dot custom-dot-${status} flex items-center justify-center -mt-[10px] -mr-[12px]`}
          style={{
            padding: "4px",
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            backgroundColor: "#00086D",
          }}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_5744_3246)">
              <path
                d="M6.75047 12.1277L4.14797 9.52523C3.85547 9.23273 3.38297 9.23273 3.09047 9.52523C2.79797 9.81773 2.79797 10.2902 3.09047 10.5827L6.22547 13.7177C6.51797 14.0102 6.99047 14.0102 7.28297 13.7177L15.218 5.78273C15.5105 5.49023 15.5105 5.01773 15.218 4.72523C14.9255 4.43273 14.453 4.43273 14.1605 4.72523L6.75047 12.1277Z"
                fill="#EEF0FF"
              />
            </g>
            <defs>
              <clipPath id="clip0_5744_3246">
                <rect width="18" height="18" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      );
      break;
    case "wait":
      dotContent = (
        <div
          className={`custom-dot custom-dot-${status} flex items-center -mt-[5px] ml-4 bg-[#B0B0C0] p-2 rounded-full`}
        />
      );
      break;
    default:
      break;
  }

  return dotContent;
};

const OverViewModalWrapper: FC<OverViewModalWrapperProps> = ({}) => {
  const [stepIndex, setStepIndex] = useState(0);
  const [paymentDetails, setPaymentDetails] = useState({
    cardNumber: "",
    name: "",
    cvv: "",
    expiry: "",
  });
  const [formData, setFormData] = useState(new FormData());
  const { locationId } = useSelector(
    (state: { calendar: { locationId: number } }) => state.calendar
  );
  const steps: ReactNode[] = [
    <DocumentsStep formData={formData} />,
    <PaymentGateway
      paymentDetails={paymentDetails}
      setPaymentDetails={setPaymentDetails}
    />,
  ];
  const { mutate, isLoading } = useMutation(
    () => uploadLocationDocuments(locationId, formData),
    {
      onSuccess: (res: any) => {
        if (res?.code !== "ERR_BAD_REQUEST") {
          queryClient.invalidateQueries(["locationDetails", locationId]);
          setStepIndex(steps.length);
          message.success(intl.formatMessage({ id: "uploadDocumentsSuccess" }));
        } else {
          message.error(intl.formatMessage({ id: "uploadDocumentsFailed" }));
        }
      },
    }
  );
  const nextStep = () => {
    if (isLoading) {
      return;
    }
    if (stepIndex === 0) {
      if (
        !formData.get("compliance_regulation") ||
        !formData.get("insurance_document") ||
        !formData.get("work_permit")
      ) {
        message.error("يجب عليك تحديد وثائق القانونية الخاصة بك");
        return false;
      } else {
        setFormData(formData);
      }
    }
    if (stepIndex === 1) {
      if (
        !paymentDetails?.cardNumber ||
        !paymentDetails?.name ||
        !paymentDetails?.cvv ||
        !paymentDetails?.expiry
      ) {
        message.error("يجب عليك تحديد معلومات الدفع");
        return false;
      }
    }
    if (stepIndex === steps.length - 1) {
      mutate();
      return;
    }
    if (stepIndex < steps.length) {
      //   searchParams.set("step", `${stepIndex + 1}`);
      //   setSearchParams(searchParams);
      setStepIndex((prev) => prev + 1);
    }

    return false;
  };
  const prevStep = () => {
    if (stepIndex > 0) {
      //   searchParams.set("step", `${stepIndex - 1}`);
      //   setSearchParams(searchParams);
      setStepIndex((prev) => prev - 1);
    }
    return false;
  };
  const intl = useIntl();
  return (
    <div className="relative     space-y-4 flex flex-col justify-center items-center">
      {stepIndex > 0 && stepIndex < steps.length ? (
        <div className="absolute -top-4 -right-7 w-full">
          <Button
            type="link"
            htmlType="button"
            onClick={prevStep}
            className="text-color-sec-title"
          >
            {backStep}
            {intl.formatMessage({ id: "go_back" })}
          </Button>
        </div>
      ) : null}
      <div className="text-center">
        <h3 className="text-color-primary font-semibold">
          {stepIndex < steps.length
            ? intl.formatMessage({ id: "enable_online_booking_for_your_salon" })
            : intl.formatMessage({ id: "you_are_done" })}
        </h3>
      </div>

      <AntSteps
        className={`!border-none`}
        progressDot={customDotRender} // Use custom dot render function
        responsive={false}
        current={stepIndex}
        items={Array(steps.length).fill({})}
      />
      <div className="max-h-[460px] overflow-y-auto  w-full flex justify-center">
        {stepIndex < steps.length ? steps[stepIndex] : <SubmittedDetails />}
      </div>
      {stepIndex < steps.length ? (
        <div onClick={nextStep} className="cursor-pointer">
          {circle3StepButton[stepIndex]}
        </div>
      ) : null}
    </div>
  );
};

export default OverViewModalWrapper;
